import { render, staticRenderFns } from "./ManageNegoReminders.vue?vue&type=template&id=cc211f52&scoped=true"
import script from "./ManageNegoReminders.vue?vue&type=script&lang=js"
export * from "./ManageNegoReminders.vue?vue&type=script&lang=js"
import style0 from "./ManageNegoReminders.vue?vue&type=style&index=0&id=cc211f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc211f52",
  null
  
)

export default component.exports